<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <ValidationObserver
                    ref="formObserver"
                    v-slot="{ invalid, validate }"
                  >
                    <b-form @submit.prevent="handleSubmit(validate)">
                      <!-- SECTION: Dados Básicos -->
                      <div class="section-title mt-3">
                        <i class="fa fa-user mr-1"></i>
                        {{ $t("Basic Information") }}
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <ValidationProvider
                            name="Name"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label for="Name">
                              <span class="required">*</span> {{ $t("Name") }}:
                            </label>
                            <b-form-input
                              id="Name"
                              type="text"
                              v-model="users.name"
                              autocomplete="new-password"
                              :state="errors.length ? false : null"
                              placeholder=""
                            />
                            <b-form-invalid-feedback :state="errors.length"
                              >{{ $t(errors[0]) }}
                            </b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-6">
                          <ValidationProvider
                            name="Email"
                            rules="required|email"
                            v-slot="{ errors }"
                          >
                            <label for="Email">
                              <span class="required">*</span> {{ $t("Email") }}:
                            </label>
                            <b-form-input
                              id="Email"
                              type="email"
                              v-model="users.email"
                              autocomplete="new-password"
                              :state="errors.length ? false : null"
                              placeholder=""
                            />
                            <b-form-invalid-feedback :state="errors.length"
                              >{{ $t(errors[0]) }}
                            </b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-4">
                          <ValidationProvider
                            name="Taxpayer Identification Number (CPF)"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label for="cpf">
                              <span class="required">*</span>
                              {{ $t("Taxpayer Identification Number (CPF)") }}:
                            </label>
                            <b-form-input
                              id="cpf"
                              type="text"
                              v-mask="'999.999.999-99'"
                              v-model="users.cpf_cnpj"
                              autocomplete="new-password"
                              :state="errors.length ? false : null"
                              placeholder=""
                            />
                            <b-form-invalid-feedback :state="errors.length"
                              >{{
                                $t("Taxpayer Identification Number (CPF)") +
                                " " +
                                $t("Required Fields")
                              }}
                            </b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-4">
                          <b-form-group label-for="rg" :label="$t('ID Card')">
                            <b-form-input
                              id="rg"
                              type="text"
                              v-mask="'99.999.999-9'"
                              v-model="users.rg"
                              autocomplete="new-password"
                              placeholder=""
                            />
                          </b-form-group>
                        </div>

                        <div class="form-group col-md-4">
                          <ValidationProvider
                            name="Date Of Birth"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label for="CellDateBrith">
                              <span class="required">*</span>
                              {{ $t("Date Of Birth") }}:
                            </label>
                            <b-form-input
                              id="CellDateBrith"
                              type="text"
                              v-mask="'99/99/9999'"
                              v-model="users.date_birth"
                              autocomplete="new-password"
                              :state="errors.length ? false : null"
                              placeholder=""
                            />
                            <b-form-invalid-feedback :state="errors.length"
                              >{{ $t(errors[0]) }}
                            </b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      <!-- SECTION: Contato & Acesso -->
                      <div class="section-title mt-3">
                        <i class="fa fa-phone mr-1"></i>
                        {{ $t("Contact & Access") }}
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-3">
                          <ValidationProvider
                            name="Cellphone"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label for="celphone">
                              <span class="required">*</span>
                              {{ $t("Cell Phone") }}:
                            </label>
                            <b-form-input
                              id="Cellphone"
                              type="text"
                              v-mask="'(99) 99999-9999'"
                              v-model="users.cellphone"
                              autocomplete="new-password"
                              placeholder=""
                              :class="{ 'is-invalid': errors.length }"
                            />
                            <span class="invalid-feedback">{{
                              $t(errors[0])
                            }}</span>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-3">
                          <b-form-group
                            label-for="Phone"
                            :label="$t('Telephone')"
                          >
                            <b-form-input
                              id="Phone"
                              type="text"
                              v-mask="'(99) 9999-9999'"
                              v-model="users.telephone"
                              autocomplete="new-password"
                              placeholder=""
                            />
                          </b-form-group>
                        </div>

                        <div class="form-group col-md-3">
                          <ValidationProvider
                            name="Access Level"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label for="inputUser">
                              <span class="required">*</span>
                              {{ $t("Access Level") }}:
                            </label>
                            <v-select
                              id="inputUser"
                              :options="profile_types"
                              :reduce="(profile_types) => profile_types.id"
                              :label="'name'"
                              v-model="users.access_level"
                              class="vselect"
                              :class="{ 'is-invalid': errors.length }"
                            />
                            <span class="invalid-feedback">{{
                              $t(errors[0])
                            }}</span>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-2">
                          <ValidationProvider
                            name="Status"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label for="status">
                              <span class="required">*</span>
                              {{ $t("Status") }}:
                            </label>
                            <b-form-select
                              id="status"
                              v-model="users.status"
                              :state="errors.length ? false : null"
                            >
                              <option value="1">{{ $t("Active") }}</option>
                              <option value="0">{{ $t("Inactive") }}</option>
                            </b-form-select>
                            <b-form-invalid-feedback :state="errors.length"
                              >{{ $t(errors[0]) }}
                            </b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-3">
                          <label for="vehicle"> {{ $t("Vehicle") }}: </label>
                          <v-select
                            id="vehicle"
                            :options="vehicles"
                            :reduce="(vehicles) => vehicles.id"
                            :label="'name'"
                            v-model="users.vehicle_id"
                            class="vselect"
                          />
                        </div>
                      </div>

                      <!-- SECTION: Senha -->
                      <div class="section-title mt-3">
                        <i class="fa fa-lock mr-1"></i>
                        {{ $t("Password") }}
                        <b-button
                          v-if="$route.params.id"
                          variant="outline-secondary"
                          size="sm"
                          class="ml-2"
                          @click="toggleFormSenha"
                        >
                          <i class="fas fa-key mr-1"></i>
                          {{
                            change_password ? $t("Hide") : $t("Change Password")
                          }}
                        </b-button>
                      </div>
                      <div class="form-row" v-if="change_password">
                        <div class="form-group col-md-6">
                          <ValidationProvider
                            name="Password"
                            rules="required|min:6"
                            v-slot="{ errors }"
                          >
                            <label for="password">
                              <span class="required">*</span>
                              {{ $t("Password") }}:
                            </label>
                            <b-input-group>
                              <b-form-input
                                id="password"
                                :type="showPassword ? 'text' : 'password'"
                                v-model="users.password"
                                autocomplete="new-password"
                                :state="errors.length ? false : null"
                                placeholder=""
                              />
                              <b-input-group-append>
                                <b-button
                                  variant="outline-secondary"
                                  @click="toggleShowPassword"
                                >
                                  <i
                                    :class="
                                      showPassword
                                        ? 'fa fa-eye-slash'
                                        : 'fa fa-eye'
                                    "
                                  ></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                            <b-form-invalid-feedback :state="errors.length"
                              >{{ $t(errors[0]) }}
                            </b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-6">
                          <ValidationProvider
                            name="Confirm The Password"
                            v-slot="{ errors }"
                          >
                            <label for="confirmPassword">
                              <span class="required">*</span>
                              {{ $t("Confirm The Password") }}:
                            </label>
                            <b-input-group>
                              <b-form-input
                                id="confirmPassword"
                                :type="showPassword ? 'text' : 'password'"
                                v-model="users.password_confirmacao"
                                autocomplete="new-password"
                                :state="errors.length ? false : null"
                                placeholder=""
                              />
                              <b-input-group-append>
                                <b-button
                                  variant="outline-secondary"
                                  @click="toggleShowPassword"
                                >
                                  <i
                                    :class="
                                      showPassword
                                        ? 'fa fa-eye-slash'
                                        : 'fa fa-eye'
                                    "
                                  ></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                            <b-form-invalid-feedback :state="errors.length"
                              >{{ $t(errors[0]) }}
                            </b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      <!-- SECTION: Empresas Vinculadas -->
                      <div class="section-title mt-3">
                        <i class="fa fa-building mr-1"></i>
                        {{ $t("Companies") }}
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-8">
                          <div class="d-flex align-items-center mb-2">
                            <v-select
                              :options="companiesForList"
                              :reduce="(c) => c.id"
                              :label="'name'"
                              v-model="newCompany"
                              class="vselect flex-grow-1"
                              :placeholder="$t('Select a company to add')"
                            />
                            <b-button
                              variant="primary"
                              size="sm"
                              class="ml-2"
                              :disabled="!newCompany"
                              @click="addCompany"
                            >
                              <i class="fa fa-plus mr-1"></i>
                              {{ $t("Add") }}
                            </b-button>
                          </div>
                          <b-list-group v-if="userCompanies.length">
                            <b-list-group-item
                              v-for="(item, index) in userCompanies"
                              :key="item.id || index"
                              class="d-flex justify-content-between align-items-center py-2"
                            >
                              <span>
                                <i class="fa fa-building-o mr-2 text-muted"></i>
                                {{ item.name }}
                              </span>
                              <b-button
                                variant="outline-danger"
                                size="sm"
                                @click="removeCompany(item)"
                                v-b-tooltip.hover
                                :title="$t('Remove')"
                              >
                                <i class="fa fa-trash"></i>
                              </b-button>
                            </b-list-group-item>
                          </b-list-group>
                          <p v-else class="text-muted small mt-1">
                            {{ $t("No companies linked yet") }}.
                          </p>
                        </div>
                      </div>

                      <!-- SECTION: Centrais Liberadas -->
                      <div class="section-title mt-3">
                        <i class="fa fa-map-marker mr-1"></i>
                        {{ $t("Centrais liberadas para visualização") }}
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-8">
                          <v-select
                            multiple
                            :options="centers"
                            :reduce="(c) => c.id"
                            :label="'name'"
                            v-model="users.center_ids"
                            class="vselect"
                            :placeholder="$t('Select the centers this user can view')"
                          />
                        </div>
                      </div>

                      <!-- SECTION: Foto -->
                      <div class="section-title mt-3">
                        <i class="fa fa-image mr-1"></i>
                        {{ $t("Profile Picture") }}
                      </div>
                      <div class="form-group col-md-8 ml-n1">
                        <b-form-group label-for="userPic">
                          <div class="user-img">
                            <img
                              v-if="previewImage"
                              :src="previewImage"
                              class="photo"
                            />
                            <img v-else class="photo" />
                          </div>
                          <upload-file
                            :fileId="users.photo"
                            :isImage="true"
                            @uploaded="
                              (event) => {
                                users.photo = event;
                              }
                            "
                            size="6rem"
                            :show-buttons="false"
                          />
                        </b-form-group>
                      </div>

                      <hr />
                      <span class="required_fields">
                        <span class="required">*</span>
                        <strong>{{ $t("Required Fields") }}</strong>
                      </span>

                      <div class="block text-right">
                        <b-button
                          variant="outline-secondary"
                          class="btn btn-back"
                          @click="$router.go(-1)"
                        >
                          <i class="fa fa-arrow-left"></i>
                          {{ $t("To Go Back") }}
                        </b-button>

                        <b-button type="submit" variant="primary" class="ml-1">
                          {{ $t("Save") }}
                          <i class="fa fa-save"></i>
                        </b-button>
                      </div>
                    </b-form>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import UploadFile from "../../layouts/components/UploadFile";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required, email, min, confirmed } from "vee-validate/dist/rules";
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BFormSelect,
  BFormInvalidFeedback,
} from "bootstrap-vue";

// Add the rules to vee-validate
extend("required", required);
extend("email", email);
extend("min", min);
extend("confirmed", confirmed);

export default {
  name: "imageUpload",
  components: {
    BaseCrud,
    vSelect,
    UploadFile,
    ValidationObserver,
    ValidationProvider,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BFormInvalidFeedback,
  },
  data() {
    return {
      change_password: true,
      showPassword: false,
      users: {
        name: "",
        email: "",
        cpf_cnpj: "",
        cellphone: "",
        telephone: "",
        photo: "",
        access_level: "",
        company_id: "",
        center_id: "",
        center_ids: [],
        unit_id: "",
        password: "",
        password_confirmacao: "",
        users_id: "",
        status: "1",
        date_birth: "",
        vehicle_id: null,
      },
      companies: [],
      profile_types: [],
      centers: [],
      units: [],
      vehicles: [],
      userCompanies: [],
      newCompany: null,
      errors: undefined,
      previewImage: null,
    };
  },
  computed: {
    companyId() {
      return this.$store.state.user.company_id > 1
        ? this.$store.state.user.company_id
        : null;
    },
    unitId() {
      return this.$store.state.user.unit_id > 1
        ? this.$store.state.user.unit_id
        : null;
    },
    companiesForList() {
      return this.companies.filter(
        (c) => !this.userCompanies.some((uc) => uc.company_id === c.id),
      );
    },
  },
  methods: {
    toggleShowPassword() {
      this.showPassword = !this.showPassword;
    },
    async handleSubmit(validate) {
      const isValid = await validate();
      if (isValid) {
        this.save();
      }
    },
    changeCenterCompany(company_id) {
      this.users.center_id = "";
      this.users.unit_id = "";
      this.users.access_level = "";
      this.centers = [];
      this.units = [];
      this.profile_types = [];

      this.getCentersCompany(company_id);
      this.getProfileTypes(company_id);
    },
    changetUnitsCenter(center_id) {
      this.users.unit_id = "";
      this.getUnitsCenter(center_id);
    },
    toggleFormSenha() {
      this.change_password = !this.change_password;
    },
    save() {
      const self = this;
      let api = self.$store.state.api + "users";

      if (!self.userCompanies.length) {
        this.$message(
          this.$t("Error"),
          this.$t("At least one company must be linked to the user"),
          "error",
        );
        return;
      }

      self.users.company_id = self.userCompanies[0]?.company_id;
      self.users.center_company_id = self.$store.state.user.company_id;

      if (self.users.id) {
        self.users._method = "PUT";
        api += "/" + self.users.id;
      }

      axios
        .post(api, this.users)
        .then((response) => {
          if (!this.users.id && response.data && response.data.id) {
            this.users.id = response.data.id;
          }
          this.saveUserCompanies();
          this.$message(
            this.$t("Success"),
            this.$t("Information saved successfully"),
            "success",
          );
          this.$router.push("/users");
        })
        .catch((error) => {
          console.log("error.response.data", error.response.data);
          this.$error(error);
        });
    },
    addCompany() {
      if (this.newCompany) {
        const found = this.companies.find((c) => c.id === this.newCompany);
        if (found) {
          this.userCompanies.push({ company_id: found.id, name: found.name });
          this.newCompany = null;
        }
      }
    },
    removeCompany(item) {
      if (item.id) {
        this.deleteUserCompany(item.id);
      } else {
        const idx = this.userCompanies.indexOf(item);
        if (idx !== -1) {
          this.userCompanies.splice(idx, 1);
        }
      }
    },
    deleteUserCompany(id) {
      const api = `${this.$store.state.api}usercompanies/${id}`;
      axios
        .delete(api)
        .then(() => {
          this.userCompanies = this.userCompanies.filter((c) => c.id !== id);
        })
        .catch((error) => {
          this.$error(error);
        });
    },
    saveUserCompanies() {
      this.userCompanies
        .filter((item) => !item.id)
        .forEach((item) => {
          const api = `${this.$store.state.api}usercompanies`;
          axios
            .post(api, { user_id: this.users.id, company_id: item.company_id })
            .catch((error) => {
              this.$error(error);
            });
        });
    },
    getUserCompanies(userId) {
      const api = `${this.$store.state.api}users/companies/${userId}`;
      axios
        .get(api)
        .then((response) => {
          this.userCompanies = response.data;
        })
        .catch((error) => {
          this.$error(error);
        });
    },
    getUserCenters(userId) {
      const api = `${this.$store.state.api}users/centers/${userId}`;
      axios
        .get(api)
        .then((response) => {
          this.users.center_ids = response.data || [];
        })
        .catch((error) => {
          this.$error(error);
        });
    },
    getUsers(id) {
      const api = `${this.$store.state.api}users/${id}`;
      axios
        .get(api)
        .then((response) => {
          const userData = response.data.data[0];
          this.users = {
            ...this.users,
            ...userData,
            cpf_cnpj: userData.cpf_cnpj || userData.cpf || "",
            password: "",
          };
          this.change_password = false;
          // this.getCentersCompany(this.users.company_id);
          // this.getUnitsCenter(this.users.center_id);
          this.getUserCompanies(userData.id);
          this.getUserCenters(userData.id);
        })
        .catch((error) => {
          this.$error(error);
        });
    },
    getCompanies(id) {
      const api = `${this.$store.state.api}companies-without-scopes`;
      axios
        .get(api)
        .then((response) => {
          this.companies = response.data;
        })
        .catch((error) => {
          this.$error(error);
        });
    },
    getVehicles: function (unit_id) {
      const self = this;
      const api = self.$store.state.api + "units/vehicles/" + unit_id;

      axios
        .get(api)
        .then((response) => {
          self.vehicles = response.data;
        })
        .catch((error) => {
          self.$message(null, self.$t(error.response.data.error), "error");
        });
    },
    getCentersCompany(company_id) {
      const api = `${this.$store.state.api}companies/centers/${company_id}`;
      axios
        .get(api)
        .then((response) => {
          this.centers = response.data;
        })
        .catch((error) => {
          this.$error(error);
        });
    },
    getUnitsCenter(center_id) {
      const api = `${this.$store.state.api}centers/unit/${center_id}`;
      axios
        .get(api)
        .then((response) => {
          this.units = response.data;
        })
        .catch((error) => {
          this.$error(error);
        });
    },
    getProfileTypes(profile_types) {
      const api = `${this.$store.state.api}profile_types/list/${profile_types}`;
      axios
        .get(api)
        .then((response) => {
          this.profile_types = response.data;
        })
        .catch((error) => {
          this.$error(error);
        });
    },
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImage = e.target.result;
      };
    },
  },
  watch: {
    "users.unit_id"(newUnitId) {
      if (newUnitId) {
        this.getVehicles(newUnitId);
      }
    },
  },
  mounted() {
    if (this.companyId) {
      this.users.company_id = this.$store.state.user.company_id;
    }

    if (this.unitId) {
      this.users.unit_id = this.$store.state.user.unit_id;
    }

    setTimeout(() => {
      this.getCompanies(this.$store.state.user.company_id);
      this.getCentersCompany(this.$store.state.user.company_id);
      this.getProfileTypes(this.$store.state.user.company_id);
    }, 2000);
    const id = this.$route.params.id;
    if (id) {
      this.change_password = false;
      this.getUsers(id);
    }
  },
};
</script>

<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}

.section-title {
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6c757d;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 6px;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
}
</style>
